import type { LocationQuery } from 'vue-router';

// The Home "Módulo" mode opens a single revision of a matrix from its folder. The folder code
// travels in this query to the record screens, so they return there instead of to the page of the
// whole code.
export const MATRIX_RETURN_FOLDER_QUERY = 'from';

const FOLDER_CODE_PATTERN = /^F\d+$/;

export function readMatrixReturnFolder(query: LocationQuery): string | null {
  const value = query[MATRIX_RETURN_FOLDER_QUERY];
  return typeof value === 'string' && FOLDER_CODE_PATTERN.test(value) ? value : null;
}
